import { VOCAB } from "../data/vocab";

const GREEN = "#1a8f68";
const AMBER = "#f0a020";
const RED = "#e24b4a";
const BORDER2 = "#e8e2d8";
const ALT = "#faf8f5";
const MUTED = "#b0a898";
const PERSIAN = "'Scheherazade New', serif";

const card = { background: "#fff", border: "1px solid #ede8df", borderRadius: 14, padding: "12px 14px" };
const eyebrow = { display: "flex", alignItems: "center", gap: 6, fontSize: 9, fontWeight: 800, color: MUTED, letterSpacing: 1.4, textTransform: "uppercase", marginBottom: 10 };

const nowHours = () => Date.now() / 3600000;

function recallProbability(w) {
  if (!w || !w.lastReviewTime) return 1;
  const elapsed = nowHours() - w.lastReviewTime;
  return Math.pow(2, -elapsed / Math.max(w.halfLife || 1, 0.001));
}

function wordOfTheDay(words) {
  if (!words || !words.length) return null;
  const dayIndex = Math.floor(Date.now() / 86400000);
  return words[dayIndex % words.length];
}

function dueForReview(wordStates, words, limit = 3) {
  const byId = Object.fromEntries((words || []).map((w) => [w.id, w]));
  return Object.values(wordStates || {})
    .filter((w) => w.lastReviewTime > 0)
    .map((w) => ({ ...w, recall: recallProbability(w), vocab: byId[w.id] }))
    .filter((w) => w.vocab && w.recall < 0.6)
    .sort((a, b) => a.recall - b.recall)
    .slice(0, limit);
}

const IcRefresh = () => (
  <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke={MUTED} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M8 1.5a6.5 6.5 0 11-6 4" /><path d="M2 2v3.5h3.5" /></svg>
);
const IcArrow = () => (
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="round"><path d="M3 8h9M8 4l4 4-4 4" /></svg>
);

export default function LearningRail({ wordStates = {}, onPractice }) {
  const wod = wordOfTheDay(VOCAB);
  const due = dueForReview(wordStates, VOCAB);
  const dueIds = due.map((d) => d.id);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {/* Word of the Day */}
      {wod && (
        <div style={{ ...card, background: `linear-gradient(150deg, #fff, ${ALT})` }}>
          <div style={eyebrow}>
            <svg width="11" height="11" viewBox="0 0 22 26" fill="none"><path d="M11 16 Q6 12 6 7.5 Q8.5 5.5 11 9 Q13.5 5.5 16 7.5 Q16 12 11 16Z" fill={GREEN} /></svg>
            Word of the Day
          </div>
          <div style={{ fontFamily: PERSIAN, fontSize: 36, fontWeight: 700, color: "#111", direction: "rtl", lineHeight: 1.15, textAlign: "center" }}>{wod.word}</div>
          <div style={{ textAlign: "center", fontSize: 13, fontWeight: 800, color: GREEN, marginTop: 4 }}>{wod.translation}</div>
          <button
            onClick={() => onPractice && onPractice("Word of the Day", [wod.id], wod.id)}
            style={{ marginTop: 10, width: "100%", padding: 8, borderRadius: 10, border: `1.5px solid ${BORDER2}`, background: "#fff", fontSize: 12, fontWeight: 700, color: "#555", fontFamily: "inherit", cursor: "pointer" }}
          >
            Practice this word
          </button>
        </div>
      )}

      {/* Due for review */}
      <div style={card}>
        <div style={eyebrow}><IcRefresh /> Due for Review · {due.length}</div>
        {due.length === 0 ? (
          <div style={{ fontSize: 11, color: MUTED, padding: "4px 0" }}>All caught up — nothing fading yet!</div>
        ) : (
          <>
            {due.map((w) => (
              <div
                key={w.id}
                onClick={() => onPractice && onPractice("Review", dueIds, w.id)}
                style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", borderRadius: 10, background: ALT, marginBottom: 6, cursor: "pointer" }}
              >
                <div style={{ fontFamily: PERSIAN, fontSize: 16, fontWeight: 700, direction: "rtl", minWidth: 44, color: "#111" }}>{w.vocab.word}</div>
                <div style={{ flex: 1, fontSize: 11, color: "#555", fontWeight: 600 }}>{w.vocab.translation}</div>
                <div style={{ width: 7, height: 7, borderRadius: "50%", background: w.recall < 0.3 ? RED : AMBER }} />
              </div>
            ))}
            <button
              onClick={() => onPractice && onPractice("Review", dueIds)}
              style={{ marginTop: 4, width: "100%", padding: 10, borderRadius: 10, border: "none", background: GREEN, color: "#fff", fontSize: 12, fontWeight: 800, fontFamily: "inherit", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
            >
              Review now <IcArrow />
            </button>
          </>
        )}
      </div>
    </div>
  );
}
